export default __webpack_public_path__ + "static/media/normas.01f36f69.svg";